import React, {FC} from "react";

interface InOutProps {
    out?: boolean
}

const InOut: FC<InOutProps> = (props) => {


    if (props?.out) return <span className="badge bg-warning bg-opacity-10 border border-warning border-opacity-25 text-warning fs-70x text-uppercase w-100 py-1.5">
        OUT
    </span>
    else return <span className="badge bg-success bg-opacity-10 border border-success border-opacity-25 text-success fs-70x text-uppercase w-100 py-1.5">
        IN
    </span>

};

export default InOut;
